const CoursesData =[
    {
        id:1,
        image:"/Images/Card_Images/web development.jpg",
        title:"web Development",
        selected:{
            title:"web development in surat with 100% placements",
            img:"/Images/courses/webdev1.png",
            overview:{
                heading1:"Why Choose Web Development?",
                description1:"The web developer follows the designer’s idea, concepts and creates the code that is used to turn them into a unique website and bring them to open for all.Web developers involved in designing a website, write web scripts using PHP Language too. Additionally, PHP developers may help maintain and update a database used for a dynamic website.The website nowadays is essential for advertising and promoting products and brands. A good web site determines all about the industry and its product in a clear way.",
                heading2:"What is the Career Growth in Web Design Course in Surat?",
            },
            CourseCover:{
                CoueseTitle1:{
                    Title1:"Web Development In PHP",
                    title1Details1:"Introduction to PHP",
                    title1Details2:"PHP Programming Basics",
                    title1Details3:"PHP & MySQL Installation",
                    title1Details4:"Object-oriented Programming In PHP"
                    
                    
                },
                CoueseTitle2:{
                    Title1:"Fundamentals of PHP",
                    title1Details1:"PHP ─ Variable Types",
                    title1Details2:"PHP ─ Constants.",
                    title1Details3:"PHP ─ Files & I/O.",
                    title1Details4:"PHP ─ GET and POST Methods"
                    
                },
                CoueseTitle3:{
                    Title1:"HTML For PHP",
                    title1Details1:"Introduction to HTML",
                    title1Details2:"Formatting Tags",
                    title1Details3:"Form Elements",
                    title1Details4:"HTML Styles",
                    title1Details5:"HTML Responsive"
                    
                },
                CoueseTitle4:{
                    Title1:"CSS In PHP",
                    title1Details1:"Introduction to CSS ",
                    title1Details2:"Syntax ",
                    title1Details3:"Transform Property ",
                    title1Details4:"Font CSS",
                    title1Details5:"Border CSS ",
                    title1Details6:"Animation Property",
                    title1Details7:"Filter Property",
                   
                },
                CoueseTitle5:{
                    Title1:"Database Connectivity MYSQL",
                    title1Details1:"Creating Databases",
                    title1Details2:"Creating Tables,Fields And Indexes",
                    title1Details3:"Writing SQL Queries",
                    title1Details4:"Subqueries, Joins, And Unions",
                    title1Details5:"Insert,update ,delete Records",
                    title1Details6:"Using Built-in Functions",
                    title1Details7:"MySQL Table Types And Transactions",
                    
                },
                CoueseTitle6:{
                    Title1:"Live Projects",
                    title1Details1:"SOCIAL MEDIA SITES",
                    title1Details2:"MANAGEMENT SITES",
                    title1Details3:"TICKET BOOKING SITES",
                    title1Details4:"E-COMMERCE"
                    
                },
                CoueseTitle7:{
                    Title1:"Fundamentals of PHP",
                    title1Details1:"PHP ─ Variable Types",
                    title1Details2:"PHP ─ Constants.",
                    title1Details3:"PHP ─ Files & I/O.",
                    title1Details4:"PHP ─ GET and POST Methods"
                    
                },
                
        }
    }
    },
    {
        id:2,
        image:"/Images/Card_Images/ui_uxdesign.jpg",
        title:"Graphic Design",
        selected:{
            title:"Learn Graphic & Animation Course with Job Placement",
            img:"/Images/courses/graphics desing.png",
            overview:{
                heading1:"What Is Graphic Design?",
                description1:"Graphic design is all about planning and projecting experiences and ideas.A graphic designer creates their ideas with textual and visual content.Graphic design illustrated creating images that demand direct attention from the viewers.This is the reason that graphic design is also known as communication design.To communicate, a graphic designer can use virtual or physical communication tools such as images, graphic forms, and words.A good career in Graphic Designing is not a simple thing. It needs a unique idea and skill. To acquire these skills learn graphics design course atCreative Design & Multimedia Institute best Graphics Design Training Institute in Surat. Graphic design is more about communicating with an audience.",
            },
            CourseCover:{
                CoueseTitle1:{
                    Title1:"Photoshop",
                    title1Details1:"Introduction to Photoshop",
                    title1Details2:"Album Page Designs",
                    title1Details3:"Product Banner Design",
                    title1Details4:"Marketing Post Design"
                    
                    
                },
                CoueseTitle2:{
                    Title1:"Illustrator",
                    title1Details1:"Introduction to Illustrator",
                    title1Details2:"Icon Design",
                    title1Details3:"3D Design",
                    title1Details4:"Perspective 3D"
                    
                },
                CoueseTitle3:{
                    Title1:"CoreIDraw",
                    title1Details1:"Introduction to CorelDraw",
                    title1Details2:"Difference b/w Raster & Vector ",
                    title1Details3:"Reshaping Objects ",
                    title1Details4:"Stamp Design ",
                    title1Details5:"Glossy Effects"
                    
                },
                CoueseTitle4:{
                    Title1:"Advanced CoreIDraw",
                    title1Details1:"Geometric Design  ",
                    title1Details2:"Visiting Card Design ",
                    title1Details3:"Brochure / Catalog Design / Flyer Design ",
                    title1Details4:"Calender Design ",
                    title1Details5:"Board Banner Design",
                    title1Details6:"Animation Property",
                    title1Details7:"Box Design",
                   
                },
                CoueseTitle5:{
                    Title1:"Adobe XD",
                    title1Details1:"Introducing Adobe XD",
                    title1Details2:"Building a Wireframe",
                    title1Details3:"Using Grids, Artboards and Repeat Grids",
                    title1Details4:"Working with Color and Creating a Color Palette",
                    title1Details5:"Prototyping Ready Designs",
                    title1Details6:"Designing a Login Screen",
                    title1Details7:"Using Device and Desktop Preview",
                    
                },
                CoueseTitle6:{
                    Title1:"Live Projects",
                    title1Details1:"Product Banner Design",
                    title1Details2:"Visiting Card",
                    title1Details3:"Web design & App design",
                    title1Details4:"Brand Logo Design"
                    
                },
                CoueseTitle7:{
                    Title1:"Fundamentals of PHP",
                    title1Details1:"PHP ─ Variable Types",
                    title1Details2:"PHP ─ Constants.",
                    title1Details3:"PHP ─ Files & I/O.",
                    title1Details4:"PHP ─ GET and POST Methods"
                    
                },
                
        }
    }
       
    },
    {
        id:3,
        image:"/Images/Card_Images/Digital_marketing.jpg",
        title:"Digital Marketing",
        selected:{
            title:"Digital Marketing Course In Surat -Learn The Definitive Guide To Digital Marketing",
            img:"/Images/courses/digital marketing.png",
            overview:{
                heading1:"Why Choose Web Development?",
                description1:"The word Digital Marketing was first introduced at the earliest of the 90s. In this competitive world, each and every business needs a unique marketing strategy Internet marketing, web marketing, or online marketing all are the same names as called digital marketing. Code Sharp is the No1 Institute in Surat offers a 100% Job Oriented Digital Marketing Course in Surat with certification. Digital Marketing is the most demanded and trendiest skill in the year 2020 which opens the door with plenty of opportunities. Digital Marketing is beyond the term “course”.                 ",
                heading2:"What is the Career Growth in Web Design Course in Surat?",
            },
            CourseCover:{
                CoueseTitle1:{
                    Title1:"Digital Markiting Overview",
                    title1Details1:"Introduction To Digital Marketing",
                    title1Details2:"Comparing Digital And Traditional Marketing",
                    title1Details3:"Digital MarketingProcess in Details",
                    title1Details4:"Visitors Engagement & Bringing Targeted Traffic"
                    
                    
                },
                CoueseTitle2:{
                    Title1:"Website Creation & Planing",
                    title1Details1:"Wordpress",
                    title1Details2:"Introduction of domain names & domain extensions",
                    title1Details3:"Introduction of web server & webhosting",
                    title1Details4:"Different types of webservers",
                    title1Details5:"Create a Creative Website",
                    
                },
                CoueseTitle3:{
                    Title1:"Search Engine Optimzation (SEO)",
                    title1Details1:"Keyword Research and Analysis",
                    title1Details2:"Competitor KeywordAnalysis",
                    title1Details3:"Search Engine Algorithms",
                    title1Details4:"Importance of Log tail & Short tail Keywords",
                    title1Details5:"Checking plagiarism for all landing pages",
                    title1Details6:"Meta DescriptionOptimization",
                    
                },
                CoueseTitle4:{
                    Title1:"Advanced SEO",
                    title1Details1:"HTML and XML Sitemap Creation",
                    title1Details2:"Robots.txt Creation",
                    title1Details3:"Canonical tag Optimization ",
                    title1Details4:"Social Media Pages integration",
                    title1Details5:"AlexaRank,MozRank ",
                    title1Details6:"Search Engine Submission",
                    title1Details7:"ArticleSubmission",
                   
                },
                CoueseTitle5:{
                    Title1:"Social Media Markiting (SMM)",
                    title1Details1:"What Are Social Media Ads?",
                    title1Details2:"Difference Between Social Media And Search Engine Ads.",
                    title1Details3:"Displaying Ads- Facebook, Twitter, LinkedIn, Instagram & YouTube",
                    title1Details4:"Effective Ads To Lead Generation",
                    title1Details5:"Creating FacebookAds",
                    title1Details6:"Communicating Value of Display on Linkedin",
                    title1Details7:"Communicating Value of Display onTwitter",
                    
                },
                CoueseTitle6:{
                    Title1:"Affiliate Marketing",
                    title1Details1:"What Is Affiliate Marketing",
                    title1Details2:"How To Find Affiliate Niche",
                    title1Details3:"Different Ways To Do Affiliate Marketing",
                    title1Details4:"Top Affiliate Marketing Networks"
                    
                },
               
                
        }
    }
      
    },
    {
        id:4,
        image:"/Images/Card_Images/mobile app development.jpg",
        title:"Mobile App Development",
        selected:{
            title:"Mobile App development in surat with 100% placements",
            img:"/Images/courses/Appdev.png",
            overview:{
                heading1:"Why Choose App Development?",
                description1:"The web developer follows the designer’s idea, concepts and creates the code that is used to turn them into a unique website and bring them to open for all.Web developers involved in designing a website, write web scripts using PHP Language too. Additionally, PHP developers may help maintain and update a database used for a dynamic website.The website nowadays is essential for advertising and promoting products and brands. A good web site determines all about the industry and its product in a clear way.",
                heading2:"What is the Career Growth in Web Design Course in Surat?",
            },
            CourseCover:{
                CoueseTitle1:{
                    Title1:"Web Development In PHP",
                    title1Details1:"Introduction to PHP",
                    title1Details2:"PHP Programming Basics",
                    title1Details3:"PHP & MySQL Installation",
                    title1Details4:"Object-oriented Programming In PHP"
                    
                    
                },
                CoueseTitle2:{
                    Title1:"Fundamentals of PHP",
                    title1Details1:"PHP ─ Variable Types",
                    title1Details2:"PHP ─ Constants.",
                    title1Details3:"PHP ─ Files & I/O.",
                    title1Details4:"PHP ─ GET and POST Methods"
                    
                },
                CoueseTitle3:{
                    Title1:"HTML For PHP",
                    title1Details1:"Introduction to HTML",
                    title1Details2:"Formatting Tags",
                    title1Details3:"Form Elements",
                    title1Details4:"HTML Styles",
                    title1Details5:"HTML Responsive"
                    
                },
                CoueseTitle4:{
                    Title1:"CSS In PHP",
                    title1Details1:"Introduction to CSS ",
                    title1Details2:"Syntax ",
                    title1Details3:"Transform Property ",
                    title1Details4:"Font CSS",
                    title1Details5:"Border CSS ",
                    title1Details6:"Animation Property",
                    title1Details7:"Filter Property",
                   
                },
                CoueseTitle5:{
                    Title1:"Database Connectivity MYSQL",
                    title1Details1:"Creating Databases",
                    title1Details2:"Creating Tables,Fields And Indexes",
                    title1Details3:"Writing SQL Queries",
                    title1Details4:"Subqueries, Joins, And Unions",
                    title1Details5:"Insert,update ,delete Records",
                    title1Details6:"Using Built-in Functions",
                    title1Details7:"MySQL Table Types And Transactions",
                    
                },
                CoueseTitle6:{
                    Title1:"Live Projects",
                    title1Details1:"SOCIAL MEDIA SITES",
                    title1Details2:"MANAGEMENT SITES",
                    title1Details3:"TICKET BOOKING SITES",
                    title1Details4:"E-COMMERCE"
                    
                },
                CoueseTitle7:{
                    Title1:"Fundamentals of PHP",
                    title1Details1:"PHP ─ Variable Types",
                    title1Details2:"PHP ─ Constants.",
                    title1Details3:"PHP ─ Files & I/O.",
                    title1Details4:"PHP ─ GET and POST Methods"
                    
                },
                
        }
    }
       
    },
    {
        id:5,
        image:"/Images/Card_Images/CC++.jpg",
        title:"C C++ Programming",
        selected:{
            title:"C, C++ Programming Course in Surat",
            img:"/Images/courses/cc++1.png",
            overview:{
                heading1:"Introduction Of C Programming Training",
                description1:"C Language is the most general programming language ever. C-language is an amazing universally useful programming language that is quick, compact and effectively accessible in all stages. At the point when an individual needs to begin a programming venture, C-language stands need to begin with it. C-language useable in the wide scope of utilizations from windows, IOS to programming which makes dynamic 3D motion pictures it must use to C-language. A large number of the language used to C-language ideas in their help record. For Learn C programming Creative Design and Multimedia is the best C Language Training institute in Surat.",
            },
            CourseCover:{
                CoueseTitle1:{
                    Title1:"Basic Concept",
                    title1Details1:"History of C Language",
                    title1Details2:"Features of C Language",
                    title1Details3:"Variable & Data Types",
                    title1Details4:"Operators & Keywords in C"
                    
                    
                },
                CoueseTitle2:{
                    Title1:"Control Statement",
                    title1Details1:"if-else",
                    title1Details2:"switch case",
                    title1Details3:"goto statement",
                    title1Details4:"Break & Continue"
                    
                },
                CoueseTitle3:{
                    Title1:"Loops & Array",
                    title1Details1:"while loop & do while loop & for loop",
                    title1Details2:"Basic Concept of Array",
                    title1Details3:"1D Array",
                    title1Details4:"2D Array",
                    title1Details5:"Multi Diamentional Array"
                    
                },
                CoueseTitle4:{
                    Title1:"Dynamic Memory Allocations",
                    title1Details1:"Pointer ",
                    title1Details2:"Structure",
                    title1Details3:"union",
                    title1Details4:"Malloc",
                    title1Details5:"Calloc ",
                    title1Details6:"Relloc",
                    title1Details7:"Garbage Collector",
                   
                },
                CoueseTitle5:{
                    Title1:"Concept of OOP",
                    title1Details1:"Introduction of OOP",
                    title1Details2:"Working with Class And Object",
                    title1Details3:"Type Conversion In Class",
                    title1Details4:"Constructor",
                    title1Details5:"Destructor",
                    title1Details6:"this pointer",
                    title1Details7:"Friend Function",
                    
                },
                CoueseTitle6:{
                    Title1:"Inheritance",
                    title1Details1:"Single inheritance",
                    title1Details2:"Multiple inheritance",
                    title1Details3:"Hierarchical inheritance",
                    title1Details4:"Hybrid inheritance"
                    
                },    
        }
    }

        
    },
    {
        id:6,
        image:"/Images/Card_Images/web design.jpg",
        title:"Web Design",
        selected:{
            title:"Web Design in surat with 100% placements",
            img:"/Images/courses/webdesign.png",
            overview:{
                heading1:"Why Choose Web Design?",
                description1:"The web developer follows the designer’s idea, concepts and creates the code that is used to turn them into a unique website and bring them to open for all.Web developers involved in designing a website, write web scripts using PHP Language too. Additionally, PHP developers may help maintain and update a database used for a dynamic website.The website nowadays is essential for advertising and promoting products and brands. A good web site determines all about the industry and its product in a clear way.",
                heading2:"What is the Career Growth in Web Design Course in Surat?",
            },
            CourseCover:{
                CoueseTitle1:{
                    Title1:"Photoshop",
                    title1Details1:"Introduction to Photoshop",
                    title1Details2:"Album Page Designs",
                    title1Details3:"Product Banner Design",
                    title1Details4:"Marketing Post Design"
                    
                    
                    
                },
                CoueseTitle2:{
                    Title1:"Illustrator",
                    title1Details1:"Introduction to Illustrator",
                    title1Details2:"Icon Design",
                    title1Details3:"3D Design",
                    title1Details4:"Perspective 3D"
                    
                },
                CoueseTitle3:{
                    Title1:"Getting Familiar with HTML",
                    title1Details1:"Introduction to HTML/HTML5",
                    title1Details2:"Formatting Tags",
                    title1Details3:"Form Elements",
                    title1Details4:"Table Layout",
                    title1Details5:"HTML Responsive"
                    
                },
                CoueseTitle4:{
                    Title1:"Make It Beautiful with CSS/CSS3",
                    title1Details1:"Types Of CSS & It's Syntax ",
                    title1Details2:"Working with Class & ID ",
                    title1Details3:"Font CSS & Border CSS & Background CSS ",
                    title1Details4:"Implementation of Icon Library",
                    title1Details5:"CSS3 Animation Property ",
                    title1Details6:"Pseudo Classes & Elements",
                    title1Details7:"Website Layout Design Using CSS/CSS3",
                   
                },
                CoueseTitle5:{
                    Title1:"Bootstrap Responsive Layout",
                    title1Details1:"Introduction to Media Query",
                    title1Details2:"Responsive Navigation Menu",
                    title1Details3:"Introduction to Bootstrap",
                    title1Details4:"Bootstrap File Implementation",
                    title1Details5:"Bootstrap Grid System",
                    title1Details6:"Bootstrap Components",
                    title1Details7:"Project Work : Responsive Website Design",
                    
                },
                CoueseTitle6:{
                    Title1:"Live Projects",
                    title1Details1:"Conversion of PSD to HTML",
                    title1Details2:"Custom Form Design",
                    title1Details3:"Slideshow Integration",
                    title1Details4:"Form validations using JS"
                    
                },   
        }
    }

    },
    {
        id:7,
        image:"/Images/Card_Images/tally.jpg",
        title:"Tally + Accounting",
        selected:{
            title:"Best Tally + Accounting Training-Learn Advance Accounting Concept",
            img:"/Images/courses/tally.png",
            overview:{
                heading1:"What is accounting? ",
                description1:"Accounting is the chronicle of monetary exchanges of a business or association.It additionally incorporates the way toward outlining, investigating and announcing these exchanges in fiscal reports. Tally ERP is the most demanding and most used accounting software.CodeSharp offer you the best tally accounting training in Surat.It is easy to use software and is designed by simple complex on the day to day activities associated with any business.",
            },
            CourseCover:{
                CoueseTitle1:{
                    Title1:"Introduction To Account",
                    title1Details1:"Rules Of  Account",
                    title1Details2:"Journal Entries",
                    title1Details3:"Trading A/C",
                    title1Details4:"Profit & Loss Account"
                    
                    
                },
                CoueseTitle2:{
                    Title1:"Introduction To Tally Accounting",
                    title1Details1:"Company Creation",
                    title1Details2:"Introduction To Ledger With Under Group",
                    title1Details3:"Ledger Creation",
                    title1Details4:"Voucher Type Creation"
                    
                },
                CoueseTitle3:{
                    Title1:"Voucher Entry",
                    title1Details1:"Purchase Order & Sales Order",
                    title1Details2:"Purchase Voucher & Sales Voucher",
                    title1Details3:"Payment Voucher & Receipt Voucher",
                    title1Details4:"Contra Voucher & Journal Voucher",
                    title1Details5:"Credit Note Voucher & Debit Note Voucher"
                    
                },
                CoueseTitle4:{
                    Title1:"Working With GST (Goods & Service Tax) ",
                    title1Details1:"Introduction of GST",
                    title1Details2:"Theory of GST",
                    title1Details3:"SGST(State Goods And Services Tax)",
                    title1Details4:"CGST(Central Goods And Services Tax)",
                    title1Details5:"IGST(Integrated Goods And Services Tax) ",
                    title1Details6:"UTGST(Union Territory Goods And Services Tax)",
                    title1Details7:"Ledger Creation Of Gst",
                   
                },
                CoueseTitle5:{
                    Title1:"Bank Transaction Entry",
                    title1Details1:"WithDraw in Bank",
                    title1Details2:"Credit cash in Bank",
                    title1Details3:"Cheque Printing",
                    title1Details4:"Cheque Register",
                    title1Details5:"Bank Reconciliation",
                    title1Details6:"Deposit Slip",
                    title1Details7:"Post Dated Entry & Due Date Entry",
                    
                },
                CoueseTitle6:{
                    Title1:"Live Projects",
                    title1Details1:"Accounting Project",
                    title1Details2:"Inventory Project",
                    title1Details3:"Loan Project",
                    title1Details4:"Multiple branch Project"
                    
                },  
        }
    }
   
    },
    {
        id:8,
        image:"/Images/Card_Images/LiveProjects.jpg",
        title:"Live Projects",
        selected:{
            title:"web development in surat with 100% placements",
            img:"/Images/courses/liveProjects2.png",
            overview:{
                heading1:"Why Choose Web Development?",
                description1:"The web developer follows the designer’s idea, concepts and creates the code that is used to turn them into a unique website and bring them to open for all.Web developers involved in designing a website, write web scripts using PHP Language too. Additionally, PHP developers may help maintain and update a database used for a dynamic website.The website nowadays is essential for advertising and promoting products and brands. A good web site determines all about the industry and its product in a clear way.",
                heading2:"What is the Career Growth in Web Design Course in Surat?",
            },
            CourseCover:{
                CoueseTitle1:{
                    Title1:"Web Development In PHP",
                    title1Details1:"Introduction to PHP",
                    title1Details2:"PHP Programming Basics",
                    title1Details3:"PHP & MySQL Installation",
                    title1Details4:"Object-oriented Programming In PHP"
                    
                    
                },
                CoueseTitle2:{
                    Title1:"Fundamentals of PHP",
                    title1Details1:"PHP ─ Variable Types",
                    title1Details2:"PHP ─ Constants.",
                    title1Details3:"PHP ─ Files & I/O.",
                    title1Details4:"PHP ─ GET and POST Methods"
                    
                },
                CoueseTitle3:{
                    Title1:"HTML For PHP",
                    title1Details1:"Introduction to HTML",
                    title1Details2:"Formatting Tags",
                    title1Details3:"Form Elements",
                    title1Details4:"HTML Styles",
                    title1Details5:"HTML Responsive"
                    
                },
                CoueseTitle4:{
                    Title1:"CSS In PHP",
                    title1Details1:"Introduction to CSS ",
                    title1Details2:"Syntax ",
                    title1Details3:"Transform Property ",
                    title1Details4:"Font CSS",
                    title1Details5:"Border CSS ",
                    title1Details6:"Animation Property",
                    title1Details7:"Filter Property",
                   
                },
                CoueseTitle5:{
                    Title1:"Database Connectivity MYSQL",
                    title1Details1:"Creating Databases",
                    title1Details2:"Creating Tables,Fields And Indexes",
                    title1Details3:"Writing SQL Queries",
                    title1Details4:"Subqueries, Joins, And Unions",
                    title1Details5:"Insert,update ,delete Records",
                    title1Details6:"Using Built-in Functions",
                    title1Details7:"MySQL Table Types And Transactions",
                    
                },
                CoueseTitle6:{
                    Title1:"Live Projects",
                    title1Details1:"SOCIAL MEDIA SITES",
                    title1Details2:"MANAGEMENT SITES",
                    title1Details3:"TICKET BOOKING SITES",
                    title1Details4:"E-COMMERCE"
                    
                },
                CoueseTitle7:{
                    Title1:"Fundamentals of PHP",
                    title1Details1:"PHP ─ Variable Types",
                    title1Details2:"PHP ─ Constants.",
                    title1Details3:"PHP ─ Files & I/O.",
                    title1Details4:"PHP ─ GET and POST Methods"
                    
                },
                
        }
    }
       
    },
    {
        id:9,
        image:"/Images/Card_Images/unity.jpg",
        title:"Game Development(UNITY)",
        selected:{
            title:"Unity 3D-The Best Tool For Game Development",
            img:"/Images/courses/gamedev1.png",
            overview:{
                heading1:"Why Choose Unity Game Development?",
                description1:"Nowadays millennial love Games, which is the most widely popular subject for refreshes, mostly like youngster kids even person love to connect with games.There is a huge scope in the gaming filed, to making a career with First Unity Game Development Training Course Institute.Unity is developed by Unity technology it is a cross-platform game development used to develop video games for PC, Laptop, mobile, and web sites. It is first developed by Apple.Unity is a cross-platform game development application that helps with creating games, manipulate games, filtration 3d games, 2d games manipulation. Unity game is written in C# language and Unity Scripts used for making components",
                heading2:"What is the Career Growth in Web Design Course in Surat?",
            },
            CourseCover:{
                CoueseTitle1:{
                    Title1:"Introduction to Game Development",
                    title1Details1:"Downloading Unity and Project Setup",
                    title1Details2:"Introduction of Unity Interface",
                    title1Details3:"IDE Basics",
                    title1Details4:"Directory Structure & Life Cycle"
                    
                    
                },
                CoueseTitle2:{
                    Title1:"Exception and Debugging",
                    title1Details1:"Run-Time Exceptions",
                    title1Details2:"Finding Run-time Errors",
                    title1Details3:"Using the Debugger",
                    title1Details4:"Difference between print() and Debug.Log() functions"
                    
                },
                CoueseTitle3:{
                    Title1:"Multiple Scenes",
                    title1Details1:"Creating New Scenes",
                    title1Details2:"Scripting Scene Changes",
                    title1Details3:"Saving Objects Across Scenes",
                    title1Details4:"Level Manger",
                    title1Details5:"Level Manger"
                    
                },
                CoueseTitle4:{
                    Title1:"Unity Engine UI",
                    title1Details1:"Images ",
                    title1Details2:"Buttons",
                    title1Details3:"Text ",
                    title1Details4:"Sliders",
                    title1Details5:"Toggle",
                    title1Details6:"Dropdown",
                    title1Details7:"Input Fields & Scroll View",
                   
                },
                CoueseTitle5:{
                    Title1:"Managing Game Objects",
                    title1Details1:"Prefabs",
                    title1Details2:"Creating and Destroying Objects",
                    title1Details3:"Activating and Deactivating Objects",
                    title1Details4:"Controlling Object Lifespans with Invoke",
                    title1Details5:"Parent-Child Objects",
                    title1Details6:"Sorting Layers",
                    title1Details7:"Tagging Game Objects",
                    
                },
                CoueseTitle6:{
                    Title1:"Live Projects",
                    title1Details1:"Puzzle Games",
                    title1Details2:"Educational Games",
                    title1Details3:"Drawing Games",
                    title1Details4:"Racing Games"
                    
                },
                
        }
    }
    },
]
export default CoursesData;